__turbopack_context__.v({
  "container": "styles-module__SAYuFW__container",
  "title": "styles-module__SAYuFW__title",
});
